/**
 * 青少年模式提醒弹窗 —— 状态判断
 *
 * 两个信号必须分开理解（后端 /api/realname/status 返回）：
 *   minor_mode  = 保护是否已生效，是合规判据。按身份分：
 *                 游客（未登录）      → 0，不强制开启，仅首页弹窗提示由用户自选
 *                 已登录但未实名      → 0，同游客：注册即受限会让产品不可用
 *                 已实名未成年        → 1，强制生效且不可关闭（合规底线）
 *                 已实名成年          → 跟随用户自己的 minor_mode 字段
 *   minor_opted = 用户是否主动开启过。游客与未实名用户恒为 0，驱动"未开启"提醒弹窗。
 *
 * minor_opted 与 minor_mode 分离的原因：已实名未成年用户的 minor_mode 恒为 1，
 * 若以它判断就永远不弹提醒；若为了弹提醒把它改成 0，内容过滤和消费拦截就失效。
 *
 * 产品规则（明确要求）：只要青少年模式没开启，每次进入首页都要弹提醒。
 * 因此这里不设"同一会话只弹一次"，也不提供"不再提示"持久化 ——
 * 未成年人保护要求每次进入都显著告知，不能靠一次勾选永久关闭。
 * （历史版本曾用 localStorage / sessionStorage 记录"已弹过""不再提示"，
 *   均导致用户勾一次后再也不弹，已全部移除。）
 */

/**
 * 判定是否应当弹出提醒弹窗。
 *
 * @param {object}  status   /api/realname/status 返回的 data
 * @param {boolean} force    true = 用户主动点击入口，无条件展开
 * @returns {boolean}
 */
export function shouldShowGuide(status, force = false) {
  if (force) return true;
  if (!status) return false;
  // 平台整体关闭青少年模式功能时不打扰
  if (status.config && Number(status.config.enabled) === 0) return false;
  // 已主动开启的用户不再提醒
  if (Number(status.minor_opted) === 1) return false;
  return true;
}
